// extracted by mini-css-extract-plugin
export default {"form":"ContactSupport_form__Sf3ZH","form-buttons-container":"ContactSupport_form-buttons-container__w+yYd"};